import { render, staticRenderFns } from "./layout-restricted-mobile-view.vue?vue&type=template&id=7b801af7"
import script from "./layout-restricted-mobile-view.vue?vue&type=script&lang=ts"
export * from "./layout-restricted-mobile-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports